module.exports = __webpack_public_path__ + "img/banner2.632e5f59.png";